<template>
    <!-- 城市筛选器主容器 -->
    <div class="type-center white-bg mt20 mb30">
        <div class="p30 cityFilter">
            <!-- 搜索区域 -->
            <div class="flex al-cn mb30">
                <el-input class="cityFilter-input" v-model="cityName" placeholder="请输入城市"/>
                <el-button class="cityFilter-button" type="primary" @click="addressPcity">开始查询</el-button>
            </div>
            <!-- 城市列表区域 -->
            <div class="cityFilter-list">
                <div class="city-content">
                    <div v-for="(provinces, letter) in cityGroups" :key="letter" class="city-group">
                        <div class="group-content">
                            <div class="letter-tag">{{ letter }}</div>
                            <div class="cities">
                                <!-- 省份列表 -->
                                <div v-for="item in provinces" :key="item.id" class="province-item">
                                    <div class="province-header">
                                        <span class="province-name discolour-blue2" @click="handleLookUp(item)">{{ item.name
                                        }}</span>
                                        <div class="city-list inline" v-show="!expandedProvinces.includes(item.name)">
                                            <div v-for="cityDistrict in item.districts" :key="cityDistrict.id"
                                                @click="handleLookUp(cityDistrict)" class="city-item">
                                                {{ cityDistrict.name }}
                                            </div>
                                        </div>
                                        <div  class="district-expand"
                                            @click="toggleProvince(item.name)">
                                            <span class="expand-text">
                                                {{ expandedProvinces.includes(item.name) ? '收起区县' : '展开区县' }}</span>
                                            <el-icon class="expand-icon"
                                                :class="{ 'is-expanded': expandedProvinces.includes(item.name) }">
                                            </el-icon>
                                        </div>
                                    </div>
                                    <!-- 市区列表 -->
                                    <div v-show="expandedProvinces.includes(item.name)" class="district-list">
                                        <div v-for="cityDistrict in item.districts" :key="cityDistrict.id"
                                            class="district-group">
                                            <span class="city-name">{{ cityDistrict.name }}</span>
                                            <div class="district-items">
                                                <div v-for="district in cityDistrict.districts" :key="district.id"
                                                    @click="handleLookUp(district)" class="district-item">
                                                    {{ district.name }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>

export default {
    components: {
    },
    data() {
        return {
            cityName: '',          // 城市名称
            cityGroups: {},        // 城市数据分组
            expandedProvinces: []  // 改用数组存储展开状态
        };
    },
    computed: {
        // 计算字母索引
        letters() {
            return Object.keys(this.cityGroups).sort();
        }
    },
    mounted() {
        this.addressPcity();
    },
    methods: {
        // 获取城市数据
        addressPcity() {
            this.$http.get(`/api/address/pcity?keyword=${this.cityName}`)
                .then(res => {
                    if (res.status == 200) {
                        this.cityGroups = res.data.data
                    } else {
                        this.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                })
        },

        // 查看详情
        handleLookUp(e) {
            localStorage.setItem("cityId", e.id);
            this.$router.go(-1);
        },

        // 切换展开状态
        toggleProvince(province) {
            const index = this.expandedProvinces.indexOf(province);
            if (index > -1) {
                this.expandedProvinces.splice(index, 1);
            } else {
                this.expandedProvinces.push(province);
            }
        },

        // 检查是否展开
        isExpanded(province) {
            return this.expandedProvinces.includes(province);
        }
    }
};
</script>
  
<style scoped lang="scss">
@import "../assets/styles/public.scss";
// eslint-disable-next-line
::v-deep .el-input__inner{
    height: 55px !important;
}
.cityFilter {
  &-list {
    border: 1px solid #D8DAE2;
    border-radius: 4px;
  }
}

.city-container {
  display: block;
  min-height: 300px;
}

.city-content {
  flex: 1;

  .city-group {
    border-bottom: 1px solid #ECECEC;
    min-height: 52px;

    &:last-child {
      border-bottom: none;
    }
  }

  .group-title {
    font-size: 14px;
    color: #333;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .cities {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    border-left: 1px solid #ECECEC;
    padding: 20px;

    .city-item {
      font-weight: 400;
      font-size: 13px;
      color: #333333;
      cursor: pointer;

      &:hover {
        color: #409EFF;
      }
    }
  }
}

.province-item {
  margin-bottom: 10px;
  width: 100%;
}

.province-header {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
}

.province-name {
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  margin-right: 20px;
  white-space: nowrap;
  flex-shrink: 0;
}

.city-list.inline {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-right: 20px;
}

.district-expand {
  display: flex;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;

  .expand-text {
    font-size: 12px;
    color: #999999;
    margin-right: 5px;
  }

  &:hover {
    color: #409EFF;

    .expand-text {
      color: #409EFF;
    }
  }
}

.expand-icon {
  font-size: 12px;
  transition: transform 0.3s;

  &.is-expanded {
    transform: rotate(180deg);
  }
}

.district-list {
  padding: 15px 0 0 20px;
}

.district-group {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  &:last-child {
    margin-bottom: 0;
  }
}

.city-name {
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  margin-right: 20px;
  white-space: nowrap;
  flex-shrink: 0;
}

.district-items {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  flex: 1;
  min-width: 0;
}

.district-item {
  font-weight: 400;
  font-size: 13px;
  color: #333333;
  cursor: pointer;

  &:hover {
    color: #409EFF;
  }
}

.county-expand {
  display: flex;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;


  .expand-text {
    font-size: 12px;
    color: #999999;
    margin-right: 5px;
  }

  &:hover {
    color: #409EFF;

    .expand-text {
      color: #409EFF;
    }
  }
}

.letter-tag {
  font-weight: 600;
  font-size: 32px;
  color: #666666;
  min-width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 20px;
}

.group-content {
  display: flex;
  gap: 20px;
  height: 100%;
}

@media screen and (min-width: 750px) {
  .cityFilter {
    &-input {
      height: 54px;
    }

    &-button {
      width: 176px;
      height: 54px;
    }
  }
}

/* 统一的移动端媒体查询 */
@media screen and (max-width: 750px) {
  .cityFilter {
    &-list {
      margin: 0 -15px;
    }
  }
  .city-content .cities {
    border-left-width: 0;
    padding-right: 15px;
    padding-top: 5px;

    .city-item {
      font-size: 12px;
      padding: 4px 8px;
    }
  }

  .letter-tag {
    font-size: 20px;
    padding-left: 10px;
    padding-top: 5px;
    min-width: 20px;
  }

  .group-content {
    gap: 5px;
    align-items: flex-start;
    flex-direction: column;
  }

  .province-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    //padding: 10px;
    position: relative;
  }

  .city-list.inline {
    margin-right: 0;
    gap: 10px;
    width: 100%;
    padding-right: 130px;
  }

  .district-expand {
    position: absolute;
    //right: 10px;
    //top: 10px;
    align-self: flex-end;
    //margin-top: -30px;
  }

  .district-group {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 0 10px;
  }

  .district-items {
    gap: 10px;
    width: 100%;
    margin-top: 5px;
  }

  .province-name,
  .city-name {
    font-size: 14px;
    margin-right: 10px;
  }

  .city-item,
  .district-item {
    font-size: 12px;
  }
}
</style>